import { TvChannel, TvChannelProgram } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { useIntl } from 'react-intl';

import { formatDuration } from '../lib/formatTime';

import { useI18n } from './useI18n';

const MIN_SECONDS_FOR_DISPLAY = 60;

interface CurrentProgramData {
    program: TvChannelProgram | null;
    time: string;
    announce: boolean;
}

export function useCurrentProgram(channel: TvChannel, now: number): CurrentProgramData {
    const intl = useIntl();
    const i18n = useI18n();

    let program = channel.getCurrentProgram(now);

    if (program) {
        const remaining = Math.max(
            Math.round(program.remaining(now) / 1000),
            MIN_SECONDS_FOR_DISPLAY
        );
        const time = i18n('card__time_left', { value: formatDuration(intl, remaining) });

        return {
            program,
            time,
            announce: false,
        };
    }

    program = channel.getNextProgram(now);

    if (program) {
        const startsIn = Math.max(
            Math.round(program.startsIn(now) / 1000),
            MIN_SECONDS_FOR_DISPLAY
        );
        const time = i18n('card__starts_in', { value: formatDuration(intl, startsIn) });

        return {
            program,
            time,
            announce: true,
        };
    }

    return {
        program: null,
        time: '',
        announce: false,
    };
}
